import type { FC } from 'react';
import { JsonLd } from './JsonLd';

export const BreadcrumbJsonLd: FC<{
  items: { name: string; url: string }[];
}> = ({ items }) => (
  <JsonLd
    data={{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.url,
      })),
    }}
  />
);
